<template>
  <form @submit.prevent="handleSubmit">
    <OverlayCard width="m" @cancel="$emit('cancel')">
      <template #title>
        {{ $t('createProjectCard.headline') }}
      </template>

      <template #content>
        <div class="overlay-card__name-grid">
          <InputBox
            :label="$t('createProjectCard.label')"
            :placeholder="$t('createProjectCard.placeholder', { name: user.firstname })"
            :error="v$.name.$error"
            :error-message="$t('createProjectCard.error.name')"
            v-model="name"
            ref="input"
            test-id="create-project-card-name"
          />

          <CircleColorPicker v-model="color" circle-icon />
        </div>

        <div class="create-project-card__comment-wrapper">
          <ProsemirrorInputBox
            :label="$t('createProjectCard.description.label')"
            data-test-id="create-project-card-comment"
            v-model="description"
            @enter="handleSubmit"
            :placeholder="$t('createProjectCard.description.placeholder')"
            :max-length="Infinity"
          />
        </div>
      </template>

      <template #footer>
        <Btn color="blue" type="submit">
          {{ $t('createProjectCard.cta') }}
        </Btn>

        <Btn color="grey" type="button" @click.prevent="$emit('cancel')">
          {{ $t('createProjectCard.cancel') }}
        </Btn>
      </template>
    </OverlayCard>
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { pick } from 'ramda';
import { required } from '@vuelidate/validators';

import { useVuelidate } from '@vuelidate/core';
import { randomColor } from '@common/codecolors/codecolors';

export default defineComponent({
  emits: { cancel: null, create: null },
  name: 'CreateProjectCard',

  setup: () => ({ v$: useVuelidate() }),

  props: {
    user: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      name: '',
      color: randomColor(),
      description: '',
    };
  },

  validations: {
    name: {
      required,
    },
  },

  methods: {
    /**
     * Handle submit.
     */
    handleSubmit() {
      this.v$.$touch();

      if (this.v$.$invalid) return;

      this.$emit('create', pick(['name', 'color', 'description'], this));
    },
  },

  /**
   * Mounted hook.
   */
  mounted() {
    this.$refs.input.focus();
  },
});
</script>

<style lang="scss">
.create-project-card__comment-wrapper {
  min-width: 0;
}
</style>
